import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import AppWrapper from '../App';
import MetroRoutes from '../routing/metroRoutes';

import { setGameType } from '../modules/game/slice';
import { store } from '../core/redux/store';
import BackgroundMusic from '../assets/sounds/metro-background.mp3';
import Bootstrap from '../components/Bootstrap';

import './../styles/index.scss';

const config = { backgroundMusicSrc: BackgroundMusic };

store.dispatch(setGameType('metro'));

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <Provider store={store}>
    <Bootstrap config={config} />
    <AppWrapper>
      <MetroRoutes />
    </AppWrapper>
  </Provider>,
);
